module.exports = __webpack_public_path__ + "static/invite-lottery.b1fbb0b4.png";